import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialCompanyFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import CompanyFilterData from "../../Companies/components/CompanyFilterData";

const CompanyArchiveFilter = ({ filterData, onSetFilterData, onCallApiAgain , from }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("companyArchiveSelectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialCompanyFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("companyArchiveFilterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleFilterChange = (value, name) => {
    let nameVal = name;
    if(name === 'owner_tags' && filterData?.tag_category === 'without'){
        nameVal = 'owner_without_tags'
    }
    onSetFilterData({ ...filterData, [nameVal]: value });
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
     count: value?.count ?? "",
      start_count: value?.start_count ?? "",
      end_count: value?.end_count ?? "",

    };
    localStorage.setItem("companyArchiveFilterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  const saveSearchFilterData = {
    count: filterData?.count,
    start_count: filterData?.start_count,
    end_count: filterData?.end_count,
  };

  return (
    <div>
      <SavedFilterComponent
        filterKey="companyArchiveFilterData"
        selectedFilterIdKey="companyArchiveSelectedSavefilterId"
        from="Company Archieves Save Filter"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialCompanyFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
          // onSetFilterData(initialCompanyFilterData);
        }}
        ref={dropdownRef}
        title={"Filter"}
        desc={"Enter company information."}
        onFilter={handleFilter}
        from="company"
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <CompanyFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} handleFilterChange={handleFilterChange} onSetFilterData={onSetFilterData} from= "companyarchive" />
      </RightModal>
    </div>
  );
};

export default CompanyArchiveFilter;
